import {get,post} from '@/api/index'

export function getTaskList(params) {
    return get('/app/task/list',params)
}

export function getTaskInfo(params){
    return get('/app/task/info',params)
}

export function shareTaskInfo(params){
    return get('/app/task/shareTaskInfo',params)
}

export function getShareCode(params){
    return get('/app/task/getShareCode',params)
}

export function cancelTask(data) {
    return post('/app/task/cancelTask', data)
}

export function completeTask(data) {
    return post('/app/task/completeTask', data)
}

export function deleteTask(data) {
    return post('/app/task/delete', data)
}

export function saveTask(data) {
    return post('/app/task/save', data)
}

export function updateTask(data) {
    return post('/app/task/update', data)
}

export function shareUpdate(data) {
    return post('/app/task/shareUpdate', data)
}

export function updateRemark(data) {
    return post('/app/task/updateRemark', data)
}

export function saveTaskLog(data) {
    return post('/app/taskLog/save', data)
}